import { HttpServiceBase } from "../../../common-services/Http/HttpServiceBase";
import { Result } from "../../../common-models/Result";
import { GetDigitalCertificatePageLinkInput } from "./GetDigitalCertificatePageLinkInput";
import { GetDigitalCertificatePageLinkOutput } from "./GetDigitalCertificatePageLinkOutput";

export class GetDigitalCertificatePageLinkService extends HttpServiceBase {

  handle = (input: GetDigitalCertificatePageLinkInput): Promise<Result<GetDigitalCertificatePageLinkOutput> | null> => {
    const promise = this.http.get<Result<GetDigitalCertificatePageLinkOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/digital-certificate-page-link`);
    return promise;
  }
}